/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, September 2020
 *
 *****************************************************************************/

import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Polygon } from "react-google-maps";

/**
 * show polygons in map for both cases 
 * if vehicle side drawer is visible and if replay side drawer is visible
 */
class AllPolygons extends PureComponent {
  render() {
    let geofences = [];
    if (this.props.showTodaysGeometry) {
      let zIndex = 1;
      geofences = this.props.todaysGeometry.map((g) => {
        return (
          <Polygon
            path={g.paths}
            key={g.id}
            onClick={() =>
              this.props.openInfoWindow(g.id, g.propertyId, g.propertyName, g.center)
            }
            options={{
              fillColor: "#8fa225",
              fillOpacity: 0.2,
              editable: false,
              draggable: false,
              strokeColor: "red",
              zIndex: zIndex++,
            }}
          />
        );
      });
    } else {
      let zIndex = 1;
      let geometries = [
        ...this.props.todaysGeometry,
        ...this.props.filteredGeometry,
      ];
      geofences = geometries.map((g) => {
        return (
          <Polygon
            path={g.paths}
            key={g.id}
            onClick={() =>
              this.props.openInfoWindow(g.id, g.propertyId, g.propertyName, g.center)
            }
            options={{
              fillColor: "#8fa225",
              fillOpacity: 0.2,
              editable: false,
              draggable: false,
              strokeColor: "red",
              zIndex: zIndex++,
            }}
          />
        );
      });
    }

    return geofences;
  }
}

const mapStateToProps = (state) => {
  return {
    todaysGeometry: state.geometry.todaysGeometry,
    filteredGeometry: state.geometry.filteredGeometry,
  };
};

export default connect(mapStateToProps, null)(AllPolygons);
